import Vue from 'vue';
const $onEvent = new Vue();
export { $onEvent };
